import { render, staticRenderFns } from "./ChoosePayment.vue?vue&type=template&id=dfd3df22&scoped=true&"
import script from "./ChoosePayment.vue?vue&type=script&lang=js&"
export * from "./ChoosePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd3df22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfd3df22')) {
      api.createRecord('dfd3df22', component.options)
    } else {
      api.reload('dfd3df22', component.options)
    }
    module.hot.accept("./ChoosePayment.vue?vue&type=template&id=dfd3df22&scoped=true&", function () {
      api.rerender('dfd3df22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChoosePayment.vue"
export default component.exports